import { createContext } from "react";
import { ITracingWrapper } from "../interfaces/ITracing";

interface ITracingContext {
    tracingFetcherWrapper: ITracingWrapper;
}

export const TracingContext = createContext<ITracingContext>({
    tracingFetcherWrapper: (fetchPromise) => (...props) => fetchPromise(...props),
});
